import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "./userHome.css";

const UserHome = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [username, setUsername] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      navigate("/");
    } else {
      setUsername(user.name || user.username || "User");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <div className="user-home-container">
      {/* Header */}
      <header className="user-home-header">
        <div className="header-left">
          <img src="/firstbench-logo.png" alt="FirstBench Logo" className="logo" />
          <div className="welcome-text">Welcome, {username}</div>
        </div>

        {/* Hamburger Icon */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Navigation */}
        <nav className={menuOpen ? "mobile-nav show" : "desktop-nav"}>
          <button
            onClick={() => {
              navigate("/user/dashboard");
              setMenuOpen(false);
            }}
            className={`nav-button ${
              location.pathname === "/user/dashboard" ? "active" : ""
            }`}
          >
            Dashboard
          </button>

          <button onClick={handleLogout} className="nav-button">
            Logout
          </button>
        </nav>
      </header>

      {/* Main Content */}
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default UserHome;
